import { type TabsSize } from "ui/tabs/tabs.types";

/**
 * Spacing multipliers per size. Figma's variables name the sizes one step down — `tabs/top-bar/medium/*`
 * is the 40px Large tab, `tabs/top-bar/small/*` the 32px Medium one.
 */
export const TOP_BAR_SIZES = {
  medium: { px: 1.5, py: 0.75, iconOnly: 1 },
  large: { px: 2, py: 1, iconOnly: 1.25 },
} as const satisfies Record<TabsSize, unknown>;

/** `tabs/bookmark/container/*` — one size. */
export const BOOKMARK_SIZE = { px: 2, py: 0.75, iconOnly: 1 } as const;

/** `tabs/sub-nav/{medium,small}/py`: the only padding a sub-nav tab has is under its label. */
export const SUB_NAV_PADDING_BOTTOM = { medium: 0.5, large: 0.75 } as const satisfies Record<TabsSize, number>;

/**
 * `tabs/sub-nav/medium/spacing`. Figma states no gap for the Medium strip, so both sizes keep this one.
 */
export const SUB_NAV_GAP = 2.5;

/** Icon to label, in every strip — `tabs/top-bar/container/spacing` and its two siblings. */
export const TAB_ICON_GAP = 0.5;

/** Figma's per-strip `icon` variables, in px. Set as a box: `assets` glyphs carry their own `width`/`height` attributes. */
export const TAB_GLYPH = { medium: 16, large: 20 } as const satisfies Record<TabsSize, number>;

export const TAB_LABEL = { medium: "buttonMedium", large: "buttonLarge" } as const satisfies Record<
  TabsSize,
  string
>;

/** `tabs/top-bar/container/stroke` — drawn inside the box in Figma, so the padding gives it back. */
export const TOP_BAR_BORDER = 1;

/** Marks the box `Tab` wraps `endIcon` in, which the strip sizes like the start icon. */
export const END_ICON_ATTRIBUTE = "data-tab-end-icon";

/** Set on an icon-only tab, which pads square where a labelled one pads wide. */
export const ICON_ONLY_ATTRIBUTE = "data-icon-only";

/** `TabPanel`'s gap under the strip, in spacing multipliers. */
export const TAB_PANEL_OFFSET = 2;
